import * as React from 'react';
import { Space } from '../../Space/src/Space.js';
import { Spinner } from '../../Spinner/src/Spinner.js';
import '../../Typography/src/Heading.js';
import '../../Typography/src/Link.js';
import '../../Typography/src/ListItem.js';
import '../../Typography/src/OrderedList.js';
import { Text } from '../../Typography/src/Text.js';
import '../../Typography/src/UnorderedList.js';
import modules_92ddc69a from '../styles/UIState.module.less.js';
import { UI_STATE_TYPES } from '../types/UIState.types.js';
import { EmptyImage } from './EmptyImage.js';

const UIState = (props) => {
    const renderDefault = (icon, title, description) => (React.createElement(Space, { className: modules_92ddc69a.container, direction: "vertical", size: 4, justify: "center", align: "center" },
        icon && React.createElement("div", { className: "mb-4" }, icon),
        React.createElement(Text, { size: 16, strong: true }, title),
        description && React.createElement(Text, { className: modules_92ddc69a.text }, description)));
    switch (props.type) {
        case UI_STATE_TYPES.LOADING:
            return renderDefault(React.createElement(Spinner, { size: 28 }), 'Собираем таблицу...');
        case UI_STATE_TYPES.EMPTY:
            return renderDefault(React.createElement(EmptyImage, null), 'Нет данных', 'Здесь пока ничего нет');
        case UI_STATE_TYPES.FILTERED_EMPTY:
            return renderDefault(React.createElement(EmptyImage, null), 'Ничего не нашли :(', 'Пожалуйста, измените поиск и попробуйте еще раз');
        default:
            return null;
    }
};

export { UIState };
//# sourceMappingURL=UIState.js.map
